import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const DOWNTIME_ANALYTICS_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('DOWNTIME_ANALYTICS');
export const DOWNTIME_ANALYTICS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	DOWNTIME_ANALYTICS_CRUD_ACTION_CONSTANTS
);
